
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AdvancedSearchCreatedResponse,
  AdvancedSearchResponse,
  ClientUserResource,
  InternalFeedbackRequest,
  ProfilesCatalog,
  SimpleError,
  ValidationError,
} from '../models';
import {
    AdvancedSearchCreatedResponseFromJSON,
    AdvancedSearchCreatedResponseToJSON,
    AdvancedSearchResponseFromJSON,
    AdvancedSearchResponseToJSON,
    ClientUserResourceFromJSON,
    ClientUserResourceToJSON,
    InternalFeedbackRequestFromJSON,
    InternalFeedbackRequestToJSON,
    ProfilesCatalogFromJSON,
    ProfilesCatalogToJSON,
    SimpleErrorFromJSON,
    SimpleErrorToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface CreateAdvancedSearchFromFileUploadRequest {
    file: Blob;
    onBehalfOfIdentity?: string;
    referralId?: string;
}

export interface ListCompanyClientsForOnBehalfOfRequest {
    clientCompanyId: string;
}

export interface SendInternalFeedbackRequest {
    advancedSearchId: string;
    internalFeedbackRequest: InternalFeedbackRequest;
}

export interface SubmitAdvancedSearchByBriefIdRequest {
    briefId: string;
}

/**
 * 
 */
export class AdvancedSearchAuthenticatedApi extends runtime.BaseAPI {

    /**
     * Create Advanced Search From File Upload
          */
    async createAdvancedSearchFromFileUploadRaw(requestParameters: CreateAdvancedSearchFromFileUploadRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AdvancedSearchCreatedResponse>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling createAdvancedSearchFromFileUpload().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['onBehalfOfIdentity'] != null) {
            queryParameters['onBehalfOfIdentity'] = requestParameters['onBehalfOfIdentity'];
        }

        if (requestParameters['referralId'] != null) {
            queryParameters['referralId'] = requestParameters['referralId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request<AdvancedSearchCreatedResponse>({
            path: `/search/api/advanced/file`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=AdvancedSearchCreatedResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Create Advanced Search From File Upload
          */
    async createAdvancedSearchFromFileUpload(requestParameters: CreateAdvancedSearchFromFileUploadRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AdvancedSearchCreatedResponse> {
        const response = await this.createAdvancedSearchFromFileUploadRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * List all catalogs of profiles
          */
    async listAllProfilesCatalogsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<ProfilesCatalog>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<ProfilesCatalog>>({
            path: `/search/api/advanced/profiles-catalogs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(ProfilesCatalogFromJSON);
        return response;
    }

    /**
     * List all catalogs of profiles
          */
    async listAllProfilesCatalogs(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<ProfilesCatalog>> {
        const response = await this.listAllProfilesCatalogsRaw(initOverrides);
        return response._data;
    }

    /**
     * Get clients of the given company to be able to create advanced search on behalf of (admin feature)
          */
    async listCompanyClientsForOnBehalfOfRaw(requestParameters: ListCompanyClientsForOnBehalfOfRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<ClientUserResource>>> {
        if (requestParameters['clientCompanyId'] == null) {
            throw new runtime.RequiredError(
                'clientCompanyId',
                'Required parameter "clientCompanyId" was null or undefined when calling listCompanyClientsForOnBehalfOf().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<ClientUserResource>>({
            path: `/search/admin/advanced/clients/{clientCompanyId}`.replace(`{${"clientCompanyId"}}`, encodeURIComponent(String(requestParameters['clientCompanyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(ClientUserResourceFromJSON);
        return response;
    }

    /**
     * Get clients of the given company to be able to create advanced search on behalf of (admin feature)
          */
    async listCompanyClientsForOnBehalfOf(requestParameters: ListCompanyClientsForOnBehalfOfRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<ClientUserResource>> {
        const response = await this.listCompanyClientsForOnBehalfOfRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Send internal feedback about AI Search relevancy
          */
    async sendInternalFeedbackRaw(requestParameters: SendInternalFeedbackRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['advancedSearchId'] == null) {
            throw new runtime.RequiredError(
                'advancedSearchId',
                'Required parameter "advancedSearchId" was null or undefined when calling sendInternalFeedback().'
            );
        }

        if (requestParameters['internalFeedbackRequest'] == null) {
            throw new runtime.RequiredError(
                'internalFeedbackRequest',
                'Required parameter "internalFeedbackRequest" was null or undefined when calling sendInternalFeedback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/search/admin/advanced/{advancedSearchId}/feedback`.replace(`{${"advancedSearchId"}}`, encodeURIComponent(String(requestParameters['advancedSearchId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalFeedbackRequestToJSON(requestParameters['internalFeedbackRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Send internal feedback about AI Search relevancy
          */
    async sendInternalFeedback(requestParameters: SendInternalFeedbackRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.sendInternalFeedbackRaw(requestParameters, initOverrides);
    }

    /**
     * Submit an advanced search by brief id
          */
    async submitAdvancedSearchByBriefIdRaw(requestParameters: SubmitAdvancedSearchByBriefIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AdvancedSearchResponse>> {
        if (requestParameters['briefId'] == null) {
            throw new runtime.RequiredError(
                'briefId',
                'Required parameter "briefId" was null or undefined when calling submitAdvancedSearchByBriefId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AdvancedSearchResponse>({
            path: `/search/api/advanced/brief/{briefId}`.replace(`{${"briefId"}}`, encodeURIComponent(String(requestParameters['briefId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AdvancedSearchResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Submit an advanced search by brief id
          */
    async submitAdvancedSearchByBriefId(requestParameters: SubmitAdvancedSearchByBriefIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AdvancedSearchResponse> {
        const response = await this.submitAdvancedSearchByBriefIdRaw(requestParameters, initOverrides);
        return response._data;
    }

}
